import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

/**
 * Directive to set aria-label on the parent element and hide all child elements
 * This allows for screen readers to read the label from single element
 */
@Directive({
    selector: '[ridangoParentAriaLabel]'
})
export class ParentAriaLabelDirective implements AfterViewInit {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngAfterViewInit() {
        const parent: HTMLElement = this.el.nativeElement;
        const label = parent.innerText.trim();
        this.renderer.setAttribute(parent, 'aria-label', label);
        Array.from(parent.children).forEach((child) => {
            this.renderer.setAttribute(child, 'aria-hidden', 'true');
        });
    }
}
